export const SUPPLIERS = `
query suppliers(
  $tenant_id: Int!,
  $skip:  Int,
  $take:  Int,
  $orderBy: SupplierOrderInput,
  $filter: FilterSupplierInput,
  $searchText: String
){
  suppliers(
    tenant_id:$tenant_id,
    skip: $skip,
    take: $take,
    orderBy: $orderBy,
    filter: $filter,
    searchText:$searchText
  ){
    __typename
    ...on Supplier{
      id
      fiscal_id
      fiscal_id_type
      name
      product_address
      status
      fantasy_name
      shipper_name
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const SUPPLIERS_SAFE = `
query suppliersSafe(
  $tenant_id: Int!,
  $skip:  Int,
  $take:  Int,
  $orderBy: SupplierOrderInput,
  $filter: FilterSupplierInput,
  $searchText: String
){
  suppliersSafe(
    tenant_id:$tenant_id,
    skip: $skip,
    take: $take,
    orderBy: $orderBy,
    filter: $filter,
    searchText:$searchText
  ){
    __typename
    ...on SupplierSafe{
      id
      fantasy_name
      crossdocking
      warehousing
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const SUPPLIER = `
query supplier(
    $id: Int!,  
){
  supplier(
    id:$id,  
  ){
    __typename
    ...on Supplier{
      id
      name
      fiscal_id_type
      fiscal_id
      product_address
      status
      logistic
      crossdocking
      warehousing
      client_id
      password
      fantasy_name
      shipper_name
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
